import { gql } from '@apollo/client';
import { SERVICE_PROVIDER } from '../fragments';

export const ARCHIVE_SERVICE_PROVIDER = gql`
  mutation archiveServiceProvider($id: ID!) {
    serviceProvider: archiveServiceProvider(id: $id) {
      ...serviceProvider
    }
  }
  ${SERVICE_PROVIDER}
`;
